import { useMutation, useQueryClient } from '@tanstack/react-query';
import campaignService from 'v2/services/campaigns';

interface CreateProductCampaignParams {
  productId: number;
  campaign: any;
}

export function useCreateProductCampaign() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ productId, campaign }: CreateProductCampaignParams) =>
      campaignService.createProductCampaign(productId, campaign),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['productCampaigns'] });
    }
  });
}
